import { MainMenu } from 'rangeConfig/@types';
import ProductList from 'rangeConfig/shared/widgets/ProductList';
import ProductSwiper from 'rangeConfig/shared/widgets/ProductSwiper';
import withProducts from 'rangeConfig/shared/widgets/withProducts';
import wallSectionsProductListConfig from './productListConfig';
import platform from 'rangeConfig/shared/utils/platform';
import ProductSortFilterWidget from 'rangeConfig/shared/widgets/ProductSortFilterWidget';
import * as R from 'ramda';
import withCategoryFilter from 'rangeConfig/shared/widgets/withCategoryFilter';

const DesktopSectionFilter = R.pipe(
  withCategoryFilter(['wall-sections', 'wall-sections-sprs-300', 'wall-sections-sprs-450'])
);
const MobileSectionFilter = R.pipe(withCategoryFilter(['wall-units']));

const widgets = {
  desktop: [
    {
      id: 'wall-sections-sort-filter-widget',
      component: ProductSortFilterWidget
    },
    {
      id: 'wall-sections-product-list',
      component: DesktopSectionFilter(withProducts(ProductList, wallSectionsProductListConfig))
    }
  ],
  mobile: [
    {
      id: 'wall-sections-product-list',
      component: MobileSectionFilter(withProducts(ProductSwiper, wallSectionsProductListConfig)),
      title: 'storageone.productListSectionsTitle'
    }
  ]
};

const mainMenu: MainMenu = {
  menuTitle: 'storageone.productListSectionsTitle',
  behaviors: {
    productGroupEntered: [],
    productGroupExited: []
  },
  filters: [],
  widgets: widgets[platform]
};

export default mainMenu;
